// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = "/auth";
const ROOTS_DASHBOARD = "/dashboard";

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, "/login"),
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, "/app"),
  },
  master: {
    root: path(ROOTS_DASHBOARD, "/master"),
    user: path(ROOTS_DASHBOARD, "/master/create-login"),
    company: path(ROOTS_DASHBOARD, "/master/company"),
    staff: path(ROOTS_DASHBOARD, "/master/staff"),
    client: path(ROOTS_DASHBOARD, "/master/client"),
    clientQrCode: path(ROOTS_DASHBOARD, "/master/client-qr-code"),
    checklistCategory: path(ROOTS_DASHBOARD, "/master/checklist-category"),
    checklist: path(ROOTS_DASHBOARD, "/master/checklist"),
    designation: path(ROOTS_DASHBOARD, "/master/designation"),
    incidentCategory: path(ROOTS_DASHBOARD, "/master/incident-category"),
    documents: path(ROOTS_DASHBOARD, "/master/documents"),
    documentTypes: path(ROOTS_DASHBOARD, "/master/document-types"),
  },
  reports: {
    root: path(ROOTS_DASHBOARD, "/reports"),
    attendanceReport: path(ROOTS_DASHBOARD, "/reports/attendance-report"),
    patrollingReport: path(ROOTS_DASHBOARD, "/reports/patrolling-report"),
    masterReport: path(ROOTS_DASHBOARD, "/reports/master-report"),
    liveTracking: path(ROOTS_DASHBOARD, "/reports/live-tracking"),
    liveTrackingHistory: path(ROOTS_DASHBOARD, "/reports/live-tracking-history"),
  },
};
